import React, { useState, useEffect } from 'react';
import {AxlPanel, AxlButton, AxlCheckbox} from "axl-reactjs-ui";
import {CircularProgress} from "@material-ui/core";

import api from '../../stores/api';
import styles from "./styles";

const requirementList = [
  {label: 'Photo POD', name: 'pod_required'},
  {label: 'Signature', name: 'signature_required'},
  {label: 'ID Scan', name: 'id_required'},
  {label: 'SMS', name: 'sms_enabled'},
]

const ShipmentRequirements = (props) => {
  const {shipment, dropoff} = props;
  const [isShowPanel, setIsShowPanel] = useState(true);
  const [allowEdit, setAllowEdit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [requirements, setRequirements] = useState({});

  useEffect(() => {
    setRequirements({
      pod_required: !!shipment.delivery_proof_photo_required,
      signature_required: !!shipment.signature_required,
      id_required: !!shipment.id_required,
      sms_enabled: !!shipment.sms_enabled,
    });
  }, [])

  useEffect(() => {
    setAllowEdit((!dropoff || dropoff.status !== 'SUCCEEDED') && shipment.status?.indexOf('CANCEL') < 0);
  }, [dropoff])

  const updateRequirement = (field) => (e) => {
    setRequirements({...requirements, [field]: e.target.checked});
  }

  const cancel = () => {
    setRequirements({
      pod_required: !!shipment.delivery_proof_photo_required,
      signature_required: !!shipment.signature_required,
      id_required: !!shipment.id_required,
      sms_enabled: !!shipment.sms_enabled,
    });
    setIsEdit(false);
    setError('');
  }

  const update = () => {
    setLoading(true);
    setError('');
    api.put(`/shipments/${shipment.id}/requirements`, requirements).then(res => {
      if (res.ok) {
        shipment.delivery_proof_photo_required = requirements.pod_required;
        shipment.signature_required = requirements.signature_required;
        shipment.id_required = requirements.id_required;
        shipment.sms_enabled = requirements.sms_enabled;

        setIsEdit(false);
      } else {
        setError(res.data.message);
      }
      setLoading(false);
    })
  }

  const renderElement = (required) => (
    <div style={{fontFamily: required ? 'AvenirNext-DemiBold' : undefined}}>{required ? 'Required' : 'Not Required'}</div>
  )

  return (
    <AxlPanel style={styles.panelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>Requirements:</div>
        <div style={styles.panelHeaderRight}>
          {allowEdit && !isEdit && (
            <div style={styles.panelHeaderButton}>
              <AxlButton tiny bg="white" onClick={() => setIsEdit(true)}>{`Edit`}</AxlButton>
            </div>
          )}
          {isEdit && (
            <div style={styles.panelHeaderButton}>
              <AxlButton tiny bg="pink" onClick={update} style={{marginRight: 5}}>{`Save`}</AxlButton>
              <AxlButton tiny bg="red" onClick={cancel}>{`Cancel`}</AxlButton>
            </div>
          )}
          <div style={styles.panelHeaderArrow} onClick={() => setIsShowPanel(!isShowPanel)}>
            <i className={!isShowPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} />
          </div>
        </div>
      </div>
      {isShowPanel && (
        <div style={{marginTop: 10}}>
          <AxlPanel.Row style={styles.panelContent}>
            {requirementList.map(req => (
              <AxlPanel.Col key={req.name} style={styles.panelCol}>
                <div style={styles.grayText}>{req.label}:</div>
                <div style={{height: 21}}>
                  {!isEdit ? (
                    renderElement(requirements[req.name])
                  ) : (
                    <AxlCheckbox checked={requirements[req.name]} onChange={updateRequirement(req.name)} />
                  )}
                </div>
              </AxlPanel.Col>
            ))}
          </AxlPanel.Row>
          {error && (
            <div style={styles.error}>{error}</div>
          )}
          {loading && (
            <div style={styles.overlay}>
              <AxlPanel.Row align="center" style={{height: '100%'}}>
                <CircularProgress color="primary" />
              </AxlPanel.Row>
            </div>
          )}
        </div>
      )}
    </AxlPanel>
  )
}

export default ShipmentRequirements;